import Vue from "vue"

import VxCard from "./vx-card/VxCard.vue";
Vue.component(VxCard.name, VxCard)

import LdButton from "./ld-button/LdButton";
Vue.component(LdButton.name, LdButton)

import VsLoaderSpinner from "./loaders/vs-loader-spinner/VsLoaderSpinner.vue";
Vue.component("VsLoaderSpinner", VsLoaderSpinner);

import FeatherIcon from "./FeatherIcon.vue"
Vue.component(FeatherIcon.name, FeatherIcon)

import VxTooltip from "./vx-tooltip/VxTooltip.vue"
Vue.component(VxTooltip.name, VxTooltip)

import LdPopoup from "./ld-popup/LdPopup.vue"
Vue.component(LdPopoup.name, LdPopoup)

import VxAutoSuggest from "./vx-auto-suggest/VxAutoSuggest.vue";
Vue.component(VxAutoSuggest.name, VxAutoSuggest)

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
Vue.component("VuePerfectScrollbar", VuePerfectScrollbar )

import LdSelect from "./ld-select/LdSelect.vue";
Vue.component(LdSelect.name, LdSelect)

import LdSelectCheckbox from "./ld-select-checkbox/LdSelectCheckbox.vue";
Vue.component(LdSelectCheckbox.name, LdSelectCheckbox)

import LdTable from "./ld-table/LdTable.vue";
Vue.component(LdTable.name, LdTable)

import LdTooltip from "./ld-tooltip/LdTooltip.vue";
Vue.component(LdTooltip.name, LdTooltip)

import LdUpload from "./ld-upload/LdUpload.vue";
Vue.component(LdUpload.name, LdUpload)
